/**
 * Dedupe rows flattened from `useLoadMore` pages on their `id` — neighbouring
 * batches can transiently hold the same row while a re-anchor cascade settles.
 * Lists mixing entity types in one stream key on something richer (see
 * use-folder-items.ts' `__typename:id`); for the common single-type list this
 * is enough.
 */
export function dedupeById<T extends { id: string | number }>(rows: readonly T[]): T[] {
  const seen = new Set<string | number>();
  const out: T[] = [];
  for (const row of rows) {
    if (seen.has(row.id)) continue;
    seen.add(row.id);
    out.push(row);
  }
  return out;
}
